/*
 The file contains the validations for partner forms. These validators can be used
 in conjunction with atlaskit Field component
*/
export const checkNonEmptyString = name => value => {
  if ((value !== null && value !== void 0 ? value : '').trim().length === 0) {
    return "".concat(name, " cannot be blank");
  }
};
export const checkNonEmptyDigits = name => value => {
  if ((value !== null && value !== void 0 ? value : '').match(/\d+/) === null || (value !== null && value !== void 0 ? value : '').match(/\s/) !== null) {
    return "".concat(name, " must be digits");
  }
};
export const checkNonEmptyAlphanumeric = name => value => {
  if ((value !== null && value !== void 0 ? value : '').match(/\w+/) === null || (value !== null && value !== void 0 ? value : '').match(/\s/) !== null) {
    return "".concat(name, " must be alphanumeric");
  }
};
export const checkMaxLength = (name, length) => value => {
  if ((value !== null && value !== void 0 ? value : '').length > length) {
    return "".concat(name, " cannot be longer than ").concat(length, " characters");
  }
};
export const checkLengthInRange = (name, min, max) => value => {
  if ((value !== null && value !== void 0 ? value : '').length < min || (value !== null && value !== void 0 ? value : '').length > max) {
    return "".concat(name, " must be between ").concat(min, " and ").concat(max, " characters long");
  }
};